import React from 'react';
import Navbar from './Navbar';
import '../team.css';

class Team extends React.Component {
  render() {
    return (
      <main>
        <Navbar />
        <div id='home'>
          <p className='heading'>Those Who Make Us Spicy</p>
          <p className='desc-heading-top'>Understanding the field</p>
          <p className='desc-desc-text'>
            Development refers to using various languages to create games (Game
            Dev), websites (Front-end and back-end Dev) as well as Apps
            (Android/iOS App Dev)
          </p>
          <p className='heading' id='#dev'>
            Web Dev
          </p>
          <main className='page-content'>
            <div
              className='card team'
              data-aos='fade-right'
              data-aos-duration='250'
            >
              <div className='content'>
                <h2 className='title'>Parth Sethi</h2>
                <p className='copy'>
                  aka <i>Sethi Ji, Pro</i>{' '}
                </p>
                <p className='copy'>Web Developer</p>
                <p className='copy'>
                  <a href='https://github.com/ParthSethiTech'>Github</a>
                </p>
              </div>
            </div>
            <div
              className='card team'
              data-aos='fade-right'
              data-aos-duration='500'
            >
              <div className='content'>
                <h2 className='title'>Rahul Tandon</h2>
                <p className='copy'>
                  aka <i>Kidnikid</i>{' '}
                </p>
                <p className='copy'>Vice President</p>
                <p className='copy'>
                  <a href='https://github.com/RahulTandon1'>Github</a>
                </p>
              </div>
            </div>
            <div
              className='card team'
              data-aos='fade-right'
              data-aos-duration='750'
            >
              <div className='content'>
                <h2 className='title'>Chirag</h2>
                <p className='copy'>
                  aka <i>Chibha, Chigga</i>{' '}
                </p>
                <p className='copy'>Unofficial prez</p>
              </div>
            </div>
            <div
              className='card team'
              data-aos='fade-right'
              data-aos-duration='1000'
            >
              <div className='content'>
                <h2 className='title'>Arghya</h2>
                <p className='copy'>
                  aka <i>Subhashchandra</i>
                </p>
                <p className='copy'>Web Developer</p>
              </div>
            </div>
            {/* <div className="card team" data-aos="fade-right" data-aos-duration="1000">
                            <div className="c   ontent">
                                <h2 className="title">Raghav Singh</h2>
                                <p className="copy">aka <i>RAGHAV</i></p><p className="copy">Web Developer</p></div>
                        </div> */}
          </main>
          <p className='heading' id='#design'>
            Design
          </p>
          <main className='page-content'>
            <div
              className='card design'
              data-aos='fade-right'
              data-aos-duration='250'
            >
              <div className='content'>
                <h2 className='title'>Aryan Singh</h2>
                <p className='copy'>
                  aka <i>Aryan Singh</i>
                </p>
                <p className='copy'>Motion Designing</p>
              </div>
            </div>
            <div
              className='card design'
              data-aos='fade-right'
              data-aos-duration='500'
            >
              <div className='content'>
                <h2 className='title'>
                  <h2>Laksh Saini</h2>
                </h2>
                <p className='copy'>
                  aka <i>Limitless Designer</i>
                </p>
                <p className='copy'> Motion Graphics, Digital Imaging</p>
              </div>
            </div>
            <div
              className='card design'
              data-aos='fade-right'
              data-aos-duration='1000'
            >
              <div className='content'>
                <h2 className='title'>Pranav Powar</h2>
                <p className='copy'>
                  aka <i>RisingPhoenix</i>
                </p>
                <p className='copy'>Motion Graphics, Movie Making</p>
              </div>
            </div>
          </main>
          <p className='heading'>Gaming</p>
          <main className='page-content' id='#gaming'>
            <div
              className='card game'
              data-aos='fade-right'
              data-aos-duration='250'
            >
              <div className='content'>
                <h2 className='title'>Ravit Gulati</h2>
                <p className='copy'>
                  aka <i>Gullusaur</i>
                </p>
                <p className='copy'>Pro Gamer, Youtuber</p>
              </div>
            </div>
            <div
              className='card game'
              data-aos='fade-right'
              data-aos-duration='250'
            >
              <div className='content'>
                <h2 className='title'>Advik</h2>
                <p className='copy'>
                  aka <i>Proxxxa</i>
                </p>
                <p className='copy'>Pro Gamer, Youtuber</p>
              </div>
            </div>
          </main>
          <p className='heading' id='#design'>
            The other eSpicians...
          </p>
          <main className='page-content'>
            <div
              className='card gems'
              data-aos='fade-right'
              data-aos-duration='250'
            >
              <div className='content'>
                <h2 className='title'>Vihaan Dhaka</h2>
                <p className='copy'>
                  aka <i>Meme Lord</i>
                </p>
                <p className='copy'>Game Dev</p>
              </div>
            </div>
            <div
              className='card gems'
              data-aos='fade-right'
              data-aos-duration='500'
            >
              <div className='content'>
                <h2 className='title'>Rushil Rawat</h2>
                <p className='copy'>
                  aka <i>Roo's Ill Rawat</i>
                </p>
                <p className='copy'>Data Science, Quiz</p>
              </div>
            </div>
            <div
              className='card gems'
              data-aos='fade-right'
              data-aos-duration='750'
            >
              <div className='content'>
                <h2 className='title'>Raghav</h2>
                <p className='copy'>
                  aka <i>Raghav-S8Y</i>
                </p>
                <p className='copy'>App Dev</p>
              </div>
            </div>
            <div
              className='card gems'
              data-aos='fade-right'
              data-aos-duration='1000'
            >
              <div className='content'>
                <h2 className='title'>Asher Kaul</h2>
                <p className='copy'>
                  aka <i>Ash</i>
                </p>
                <p className='copy'>Everything You Can Ask For</p>
              </div>
            </div>
            <div
              className='card gems'
              data-aos='fade-right'
              data-aos-duration='1000'
            >
              <div className='content'>
                <h2 className='title'>Vishesh 👨‍🦱</h2>
                <p className='copy'>
                  aka <i>Vishesh</i>
                </p>
                <p className='copy'>Competitive Programming</p>
              </div>
            </div>
            <div
              className='card gems'
              data-aos='fade-right'
              data-aos-duration='1000'
            >
              <div className='content'>
                <h2 className='title'>Arnav Bansal</h2>
                <p className='copy'>
                  aka <i>tperm</i>
                </p>
                <p className='copy'>App Dev</p>
              </div>
            </div>
            <div
              className='card gems'
              data-aos='fade-right'
              data-aos-duration='1000'
            >
              <div className='content'>
                <h2 className='title'>Varaang</h2>
                <p className='copy'>
                  aka <i>Ramsay</i>
                </p>
                <p className='copy'>Movie making,Hardware and robotics</p>
              </div>
            </div>
            <div
              className='card gems'
              data-aos='fade-right'
              data-aos-duration='1000'
            >
              <div className='content'>
                <h2 className='title'>Arnav Gupta</h2>
                <p className='copy'>
                  aka <i>Arnav</i>
                </p>
                <p className='copy'>Competitive Programming</p>
              </div>
            </div>
            <div
              className='card gems'
              data-aos='fade-right'
              data-aos-duration='1000'
            >
              <div className='content'>
                <h2 className='title'>Ayush</h2>
                <p className='copy'>
                  aka <i>ayush</i>
                </p>
                <p className='copy'>App Dev, Quiz and Cross</p>
              </div>
            </div>
          </main>
        </div>
      </main>
    );
  }
}

export default Team;
